import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconInfoSvg } from "./IconInfoSvg.mjs";
const IconInfo = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconInfoSvg, ...iconProps });
};
export {
  IconInfo
};
